
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Cabbookingforweddinginpune() {



    const cardData =
    {
        keyword: ' Cab booking for wedding in Pune',
        heading: 'Prince Cabs: Cab booking for wedding in Pune',
        headingDescription: 'Prince Cabs provides premium Cab Booking for Wedding in Pune, ensuring stylish, comfortable, and reliable transportation on your special day. Our fleet includes luxury sedans, spacious SUVs, and premium vehicles like Innova Crysta and Kia Carens, perfect for bridal entry, family members, and guest transfers. With professional chauffeurs, punctual service, and flexible booking options, we make wedding travel smooth and stress-free. Choose Prince Cabs’ trusted wedding cab booking service in Pune to add comfort, elegance, and reliability to your celebrations.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was the majestic seat of the Peshwas of the Maratha Empire. Its grand stone walls, massive gates, and sprawling courtyards narrate tales of bravery and politics. Though partially destroyed by fire in 1828, its ruins still showcase Pune’s glorious past. The evening light-and-sound show recreates Maratha history with drama and pride. Visitors enjoy exploring the gardens and old fortifications. Shaniwar Wada remains Pune’s most iconic landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is one of Pune’s most treasured monuments. During the Quit India Movement, Mahatma Gandhi and Kasturba Gandhi were imprisoned here. Today, the palace houses a museum with photographs, letters, and personal artifacts of Gandhi. Its vast lawns provide a peaceful retreat for visitors. The monument is recognized as a national heritage site. It is a timeless symbol of sacrifice and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, about 30 km from Pune, is known for the 1670 battle where Tanaji Malusare fought bravely for the Marathas. The fort’s ruins, bastions, and watchtowers offer glimpses into history. Trekkers love the scenic climb, especially during monsoon when the hills turn lush green. From the top, views of the Sahyadri ranges are breathtaking. Local vendors serve traditional pithla-bhakri, enhancing the experience. Sinhagad is a mix of history, adventure, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous religious site, dedicated to Lord Ganesha. The idol, adorned with gold ornaments, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of cultural celebrations. It is also known for its charitable contributions and social work. Its central location makes it easily accessible for locals and tourists. It is both a spiritual and cultural icon of Pune."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill is one of Pune’s highest points, offering sweeping views of the city. At the summit lies the Parvati Temple complex, dedicated to Lord Shiva and Goddess Parvati. Visitors climb over 100 steps to reach this spiritual and historical site. The Peshwa Museum nearby displays Maratha-era artifacts. Sunrises and sunsets from the hill are especially enchanting. Parvati Hill blends devotion, heritage, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, a sanctum with a Shiva linga, and a stone-carved Nandi. Despite being in the city center, it offers a calm and meditative environment. The temple reflects Rashtrakuta-era architectural brilliance. Visitors admire its historical and spiritual charm. It is one of Pune’s hidden heritage gems."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include sculptures, paintings, musical instruments, and everyday objects from across India. A highlight is the recreated Mastani Mahal, reflecting Maratha history. The museum fascinates both art lovers and history buffs. It reflects the cultural richness of Maharashtra. This museum is one of Pune’s most unique attractions."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global retreat for wellness and spirituality. Visitors from across the world come here for meditation, yoga, and therapy programs. Surrounded by serene gardens and modern architecture, it offers peace and relaxation. The ashram promotes holistic growth and mindfulness. Its vibrant international community adds cosmopolitan flavor. It is a unique blend of spirituality and lifestyle."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity in Viman Nagar is Pune’s largest shopping and lifestyle destination. It houses global and Indian retail brands, multiplex cinemas, and entertainment zones. The mall also offers gourmet dining experiences and seasonal events. Families love it for a complete day of shopping and leisure. It represents the modern and urban side of Pune. Phoenix Marketcity is the city’s ultimate retail hub."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, about 20 km from Pune, is a favorite picnic and weekend spot. It provides water to the city and is surrounded by scenic hills. Families enjoy street food, boating, and evening walks here. The monsoon season transforms it into a lush paradise with misty views. Cool breezes make evenings refreshing by the waterside. Khadakwasla is Pune’s peaceful natural retreat."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by the Mulshi Dam, is a serene destination near Pune. Surrounded by forests, waterfalls, and Sahyadri hills, it is perfect for camping and photography. Monsoon enhances its beauty with greenery and mist. Eco-resorts nearby offer a cozy stay for families and couples. Trekkers also love its trails and scenic landscapes. Mulshi is an ideal spot for nature and relaxation."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Chaturshringi Temple, on Senapati Bapat Road, is one of Pune’s oldest shrines dedicated to Goddess Chaturshringi. Devotees climb more than 100 steps to reach the sanctum. The temple is vibrant during Navratri with cultural and religious festivities. Thousands of pilgrims visit to seek blessings year-round. Its hilltop setting offers panoramic city views. It is both a spiritual and cultural landmark."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "The National War Memorial in Pune honors soldiers who sacrificed their lives post-independence. It displays tanks, weapons, and war memorabilia. A museum inside narrates stories of India’s military history. The evening flag retreat ceremony is deeply moving. Families and students visit to pay respects and learn patriotism. It is a place of pride and remembrance for the armed forces."
  },
  {
    "title": "Empress Garden",
    "description": "Empress Garden, spread across 39 acres, is a botanical park with exotic plants and shaded walkways. Managed by the Agri-Horticultural Society, it is one of Pune’s oldest gardens. Families visit for picnics, leisure walks, and relaxation. The annual flower show is a major attraction for nature lovers. Its colonial heritage adds historical charm. Empress Garden is a peaceful green escape within the city."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, the highest hill in Pune, is a favorite among joggers, cyclists, and nature lovers. The hilltop offers sweeping views of the entire city. It is rich in biodiversity, with birds and native flora adding to its charm. Sunrises and sunsets from here are especially captivating. Locals come for morning yoga and fitness activities. Vetal Hill is Pune’s natural lung and a serene retreat."
  }
],

"services": [
  {
    "name": "Wedding Car Hire Pune",
    "description": "Book well-maintained and elegant cars for wedding functions in Pune. Choose from a variety of vehicles including sedans, SUVs, and premium cars to match your celebration’s style and comfort requirements. Ideal for groom’s entry, bridal pickup, and guest transportation."
  },
  {
    "name": "Luxury Car for Marriage Pune",
    "description": "Arrive in style on your big day with luxury car rentals in Pune for weddings. From Mercedes to BMW, choose high-end vehicles with chauffeurs that add class and sophistication to your wedding procession."
  },
  {
    "name": "Wedding Cab Booking Hinjewadi",
    "description": "Convenient cab booking services for wedding functions in Hinjewadi, Pune. Whether it’s transporting guests or arranging bridal and groom cars, get timely and reliable service tailored to your event schedule."
  },
  {
    "name": "Innova Crysta for Wedding Pune",
    "description": "Hire premium Innova Crysta for wedding functions in Pune, ideal for comfortable guest transfers or family members who need extra space and comfort during ceremonies and travel."
  },
  {
    "name": "Sedan for Wedding Guests Pune",
    "description": "Rent stylish and comfortable sedans like Dzire and Etios for wedding guest transportation across Pune. Ensures a smooth, AC ride experience for attendees traveling to venues or hotels."
  },
  {
    "name": "SUV Cab for Wedding Pune",
    "description": "Book spacious SUV cabs for weddings in Pune that are perfect for accommodating luggage and guests in comfort. A practical and elegant choice for family travel during wedding events."
  },
  {
    "name": "Wedding Car Rental with Driver Pune",
    "description": "Choose chauffeur-driven wedding car rentals in Pune for a stress-free and smooth transportation experience. Professional drivers ensure timely arrivals and courteous service throughout the event."
  },
  {
    "name": "Pune Wedding Ertiga Cab",
    "description": "Hire Ertiga cabs for weddings in Pune offering 7-seater comfort and space for group or family travel. Ideal for transferring close relatives between venues or hotels."
  },
  {
    "name": "Tempo Traveller for Wedding Pune",
    "description": "Rent 9, 12, or 17-seater Tempo Travellers for wedding guest transport in Pune. Best suited for large groups traveling together to multiple event venues comfortably and economically."
  },
  {
    "name": "Cab Booking for Baraat Pune",
    "description": "Book decorative or regular cabs for baraat processions in Pune. A convenient and stylish transport solution for the groom’s entry and accompanying friends and family."
  },
  {
    "name": "AC Cab for Marriage Function Pune",
    "description": "Ensure guest comfort with AC cab rentals for marriage functions in Pune. Available in multiple categories from sedans to SUVs to accommodate varying travel needs."
  },
  {
    "name": "Swift Dzire for Wedding Pune",
    "description": "Rent Swift Dzire cars for weddings in Pune, a budget-friendly yet elegant option for guest pickup, drop, or staff transport. Clean and presentable vehicles guaranteed."
  },
  {
    "name": "Pune Wedding Transport Service",
    "description": "Comprehensive wedding transport solutions in Pune for all your big day logistics — guest pick-ups, bridal entry, venue transfers, and more with a range of vehicle options and full coordination support."
  },
  {
    "name": "Wedding Family Car Hire Pune",
    "description": "Hire family-sized vehicles for wedding functions in Pune to make travel for your relatives easy and coordinated. Options include Ertiga, Crysta, and Tempo Travellers for groups of all sizes."
  },
  {
    "name": "Affordable Wedding Cab Pune",
    "description": "Get affordable cab rentals for wedding events in Pune without compromising on comfort or quality. Best for guest logistics, day-long functions, and outstation travel."
  }
],
"tableData": [
  ["Wedding Car Hire Pune", "Luxury Car for Marriage Pune"],
  ["Wedding Cab Booking Hinjewadi", "Innova Crysta for Wedding Pune"],
  ["Sedan for Wedding Guests Pune", "SUV Cab for Wedding Pune"],
  ["Wedding Car Rental with Driver Pune", "Pune Wedding Ertiga Cab"],
  ["Tempo Traveller for Wedding Pune", "Cab Booking for Baraat Pune"],
  ["AC Cab for Marriage Function Pune", "Swift Dzire for Wedding Pune"],
  ["Pune Wedding Transport Service", "Wedding Family Car Hire Pune"],
  ["Affordable Wedding Cab Pune"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Wedding Cab Booking Service in Pune",
    "WhyChoosedescription": "Prince Cabs offers dependable and professional cab services for weddings in Pune. Whether it's for the bride and groom, family members, or guests, we ensure smooth, punctual, and comfortable transportation for all wedding-related events. From venue transfers to airport pickups, our service adds convenience and elegance to your special occasion."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Every Wedding Need",
    "WhyChoosedescription": "We provide a diverse fleet of vehicles, including sedans, SUVs, luxury cars, and 7-seaters like Ertiga and Innova Crysta, to match your wedding requirements. Whether it’s guest pickups, VIP arrivals, or bridal entry, our well-maintained, air-conditioned vehicles ensure everyone travels in style and comfort."
  },
  {
    "WhyChooseheading": "Customizable Packages for Wedding Events",
    "WhyChoosedescription": "Choose from flexible packages that cater to full-day rentals, hourly bookings, multi-day weddings, or intercity guest transport. Whether you need a single cab or a fleet of vehicles, Prince Cabs offers tailored options for Mehendi, Sangeet, Haldi, Reception, and Wedding Day functions with professional coordination."
  },
  {
    "WhyChooseheading": "Professional Drivers with Event Experience",
    "WhyChoosedescription": "Our drivers are punctual, well-dressed, and experienced in handling wedding transportation. They are trained to assist guests courteously, navigate between venues efficiently, and ensure a smooth, pleasant travel experience throughout the wedding functions."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer competitive and clearly structured wedding cab packages with no last-minute surprises. Pricing includes fuel, tolls, driver charges, and taxes. Choose from various payment modes like UPI, cards, net banking, and cash for added convenience."
  },
  {
    "WhyChooseheading": "Well-Maintained, Clean & Decor-Ready Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly cleaned, sanitized, and maintained for comfort and safety. Need decorated cars for the bride and groom? We also offer cab decoration options on request to add that festive touch to your wedding transportation."
  },
  {
    "WhyChooseheading": "24/7 Support & Coordination for Wedding Logistics",
    "WhyChoosedescription": "Our dedicated wedding travel coordinators and 24/7 customer support team ensure smooth logistics across multiple venues and guest schedules. We manage last-minute changes, provide real-time driver coordination, and help make your wedding transport experience stress-free and elegant."
  }
]































    }

const faqData = [
    {
        question: 'Does Prince Cabs offer cab booking services for weddings in Pune?',
        answer: 'Yes, Prince Cabs provides reliable and elegant cab services for weddings in Pune, including transportation for guests, family, and the wedding party.',
    },
    {
        question: 'What types of vehicles are available for wedding cab bookings?',
        answer: 'We offer a wide range of vehicles including Swift Dzire, Ertiga, Innova, Tempo Traveller, and luxury cars to suit various wedding needs.',
    },
    {
        question: 'Can Prince Cabs handle multiple vehicle bookings for wedding events?',
        answer: 'Absolutely! We can manage bulk bookings and coordinate multiple vehicles efficiently for your entire wedding schedule.',
    },
    {
        question: 'Are the wedding cabs well-maintained and presentable?',
        answer: 'Yes, all wedding cabs are thoroughly cleaned, sanitized, and maintained to look presentable for your special day.',
    },
    {
        question: 'Can I hire a decorated cab for the bride and groom?',
        answer: 'Yes, Prince Cabs can arrange for specially decorated vehicles for the bride and groom upon request.',
    },
    {
        question: 'What are the charges for wedding cab bookings in Pune?',
        answer: 'Charges depend on the type and number of vehicles, duration, and distance. Contact Prince Cabs for a customized quote.',
    },
    {
        question: 'How do I book cabs for a wedding in Pune?',
        answer: 'You can book through our website or contact our customer support to discuss your requirements and receive a tailored package.',
    },
];

const testimonials = [
    {
        name: "Mr. Ankit Joshi",
        position: "Groom’s Brother",
        text: "We booked multiple cabs from Prince Cabs for my brother’s wedding in Pune. The service was flawless, and the vehicles were clean and on time.",
        image: "/img/testimonial/testimonial-thumb-wedding-pune-1.png",
    },
    {
        name: "Mrs. Kavita Deshmukh",
        position: "Bride’s Aunt",
        text: "Prince Cabs took care of all guest transport during the wedding. The drivers were courteous and the entire process was smooth.",
        image: "/img/testimonial/testimonial-thumb-wedding-pune-2.png",
    },
];













































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Cab Booking for Wedding in Pune",
  "description": "Reliable and affordable wedding car hire services in Pune including luxury cars, Innova Crysta, Sedans, SUVs, Ertiga, Tempo Traveller, and AC cabs for marriage functions and baraat transport.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Wedding Car Hire Pune",
    "Luxury Car for Marriage Pune",
    "Wedding Cab Booking Hinjewadi",
    "Innova Crysta for Wedding Pune",
    "Sedan for Wedding Guests Pune",
    "SUV Cab for Wedding Pune",
    "Wedding Car Rental with Driver Pune",
    "Pune Wedding Ertiga Cab",
    "Tempo Traveller for Wedding Pune",
    "Cab Booking for Baraat Pune",
    "AC Cab for Marriage Function Pune",
    "Swift Dzire for Wedding Pune",
    "Pune Wedding Transport Service",
    "Wedding Family Car Hire Pune",
    "Affordable Wedding Cab Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Cab Booking for Wedding in Pune | Luxury & Affordable Wedding Cars</title>
  <meta
    name="description"
    content="Book reliable and affordable wedding car hire in Pune including luxury cars, Innova Crysta, Sedans, SUVs, Ertiga, Tempo Traveller, and AC cabs for marriage functions and baraat transport."
  />
  <meta
    name="keywords"
    content="Wedding Car Hire Pune, Luxury Car for Marriage Pune, Wedding Cab Booking Hinjewadi, Innova Crysta for Wedding Pune, Sedan for Wedding Guests Pune, SUV Cab for Wedding Pune, Wedding Car Rental with Driver Pune, Pune Wedding Ertiga Cab, Tempo Traveller for Wedding Pune, Cab Booking for Baraat Pune, AC Cab for Marriage Function Pune, Swift Dzire for Wedding Pune, Pune Wedding Transport Service, Wedding Family Car Hire Pune, Affordable Wedding Cab Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabbookingforweddinginpune ;